<template>
  <nuxt-link
    v-bind="$attrs"
    :class="classes"
  >
    <slot />
  </nuxt-link>
</template>

<script setup lang="ts">
export interface Props {
  color?: string
  bold?: boolean
}
const props = withDefaults(defineProps<Props>(), {
  color: 'interactive',
  bold: false,
})

const classes = computed(() => {
  const classArray = [
    `text-${props.color}`,
    'text-decoration-none'
  ]
  if (props.bold) {
    classArray.push('font-weight-bold')
  }

  return classArray
})
</script>

<!--<style scoped lang="scss">-->
<!--</style>-->
